import { DateFormatType } from './date-format-key'
import { TimeFormatType } from './time-format-key'
import { resolveDateFormat } from './resolve-date-format'
import { resolveTimeFormat } from './resolve-time-format'

export function serializeReportDateFormat(
  timeFormat: TimeFormatType | null,
  dateFormat: DateFormatType | null,
): string {
  return `${resolveTimeFormat(timeFormat)}_${resolveDateFormat(dateFormat)}`
}
